import { Navigate, Route } from 'react-router-dom';
import { MemberIdRedirect } from './MemberIdRedirect';

/**
 * Legacy route redirects, exported as the actual `<Route>` elements that App.tsx
 * renders. Exporting the shipped element (path + target + `replace`) - rather
 * than re-declaring an equivalent in a test - means the redirect regression test
 * consumes exactly what production ships and cannot drift from it (Rule 46: a
 * test that mounts its own inline <Navigate> is a vacuous guard).
 *
 * `/me/notifications` -> `/settings/notifications`: the notification surfaces
 * were consolidated to a single page (#2652); this preserves the old bookmarked
 * URL. `replace` is load-bearing so Back does not bounce off the redirect.
 */
export const meNotificationsRedirectRoute = (
  <Route path="me/notifications" element={<Navigate to="/settings/notifications" replace />} />
);

/**
 * `/member/:id` -> `/u/:id`: the protected `MemberDetailPage` was retired (#3348).
 * It fetched `GET /members/:id`, an endpoint no backend router ever mounted, so the
 * page could only ever render its error state; no rendered link reached the route
 * (the live roster already links to `/u/:id`, `ClubMembersPage.tsx`). This forwards
 * any old bookmarked/shared `/member/:id` link to the public profile with the `:id`
 * preserved. `replace` so Back does not bounce off the redirect.
 *
 * The `<Navigate>` cannot interpolate a route param, so `MemberIdRedirect` (its own
 * module, so this route-definitions file keeps exporting only `<Route>` elements and
 * stays clear of react-refresh/only-export-components) reads the `:id` and builds the
 * target; the shipped `<Route>` element is exported (Rule 46) so the regression test
 * consumes exactly what App.tsx renders.
 */
export const memberIdRedirectRoute = (
  <Route path="member/:id" element={<MemberIdRedirect />} />
);
